import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import { Dropdown } from "primereact/dropdown";
import { useGlobalContext } from "../../../Config";
import { ProductService } from "../../../services/ProductService.js";
import { getEmpresas } from "../../../services/SubproductoService.js";
import { esIncluido } from "../../../utilities/valorEsIncluido.js";

const productService = new ProductService();


const FormCrearProductoSubproducto = ({
    displayDialogProductoSubproducto,
    setDisplayDialogProductoSubproducto,
    empresa,
    loading,
    setLoading,
    baseUrl,
    nombreEmpresa,
    productos,
    fetchData
}) => {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [subproductos, setSubproductos] = useState([]);
    const [selectedSubproducto, setSelectedSubproducto] = useState(null);
    const { baseUrl: ctxBaseUrl } = useGlobalContext();

    const cerrarYLimpiar = () => {
        setSelectedProduct(null);
        setSelectedSubproducto(null);
        setSubproductos([]);
        setDisplayDialogProductoSubproducto(false);
    };

    const loadSubproductos = async () => {
        try {
            setLoading?.(true);
            const urlBase = baseUrl || ctxBaseUrl;
            const data = await productService.getSubproductosEntidad(urlBase);
            const lista = Array.isArray(data.subproductos) ? data.subproductos : [];
            const nombresEmpresas = {};
            try {
                const empresas = await getEmpresas(urlBase);
                (empresas || []).forEach((e) => {
                    nombresEmpresas[e.id] = e.nombre;
                });
            } catch (e) {
                console.error("Error al obtener empresas:", e);
            }
            setSubproductos(
                lista
                    .filter((sub) => sub.activo === true || sub.activo === 1)
                    .map((sub) => ({
                        ...sub,
                        label:
                            sub.descripcion +
                            (sub.id_empresa && nombresEmpresas[sub.id_empresa]
                                ? ` (${nombresEmpresas[sub.id_empresa]})`
                                : ""),
                    }))
            );
        } catch (e) {
            console.error("Error al obtener subproductos:", e);
        } finally {
            setLoading?.(false);
        }
    };

    useEffect(() => {
        setProducts(Array.isArray(productos) ? productos : []);
    }, [productos]);

    useEffect(() => {
        if (displayDialogProductoSubproducto) {
            loadSubproductos();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayDialogProductoSubproducto]);

    const handleInsert = async () => {
        if (!empresa || !selectedProduct?.id || !selectedSubproducto?.id) return;
        try {
            setLoading?.(true);
            const urlBase = baseUrl || ctxBaseUrl;
            await productService.insertProductoSubproductoEntidad(urlBase, {
                idEmpresa: empresa,
                idProducto: selectedProduct.id,
                idSubproducto: selectedSubproducto.id,
            });
            alert("Subproducto asociado correctamente.");
            cerrarYLimpiar();
        } catch (error) {
            console.error("Error insertando subproducto:", error);
            alert(error.message || "Error al asociar subproducto");
        } finally {
            fetchData();
        }
    };

    return (
        <Dialog
            header={`Asociar Subproducto`}
            visible={displayDialogProductoSubproducto}
            className="p-fluid product-dialog"
            onHide={cerrarYLimpiar}
            footer={
                <div className="flex justify-content-end">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-rounded p-button-outlined"
                        onClick={cerrarYLimpiar}
                    />
                    <Button
                        label="Guardar"
                        icon="pi pi-save"
                        className="p-button-rounded p-button-success p-button"
                        raised
                        onClick={handleInsert}
                        disabled={!selectedProduct || !selectedSubproducto || loading}
                    />
                </div>
            }
        >
        <div className="p-grid p-formgrid p-fluid">
            {/* SECCIÓN 1: SELECCIÓN DE PRODUCTO Y SUBPRODUCTO */}
            <div className="col-12 mb-2">

                <span className="p-float-label mt-2 mb-2">
                    <Dropdown
                        value={selectedProduct}
                        options={products}
                        onChange={(e) => setSelectedProduct(e.value)}
                        optionLabel="descripcion"
                        placeholder="Seleccione un producto"
                        className="w-full"
                    />
                    <label htmlFor="producto">Producto ({nombreEmpresa})</label>
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <span className="p-float-label" style={{ width: "100%" }}>
                        <Dropdown
                            id="tipoSubP"
                            value={selectedSubproducto}
                            onChange={(e) => setSelectedSubproducto(e.value)}
                            options={subproductos}
                            optionLabel="label"
                            placeholder="Seleccione un subproducto"
                            className="w-full"
                        />
                        <label htmlFor="tipoSubP">Subproducto</label>
                    </span>

                    {selectedSubproducto && (
                        <>
                            <span className="text-sm text-gray-600">
                                Tipo:{" "}
                                {selectedSubproducto?.tipo} - {esIncluido(selectedSubproducto?.incluido)
                                ? "Incluido"
                                : "Adicional"}
                            </span>

                            <span className="text-sm text-gray-600">
                                Metraje: {selectedSubproducto?.metraje ?? "-"} m²
                            </span>

                            <span className="text-sm text-gray-600">
                                Tarifa: {selectedSubproducto?.tarifa_base ?? "-"}{" "}
                                {selectedSubproducto?.moneda ?? ""}
                            </span>
                        </>
                        )
                    }
                </div>
            
            </div>
        </div>
        </Dialog>
    );
};

export default FormCrearProductoSubproducto;
